import { call, put, takeLatest } from 'redux-saga/effects';
import { message } from 'antd';
import {
  FETCH_SCORING_CONFIG,
  fetchScoringConfigSuccess,
  fetchScoringConfigFail,
  SAVE_SCORING_CONFIG,
  saveScoringConfigSuccess,
  saveScoringConfigFail,
  RESET_SCORING_CONFIG,
  resetScoringConfigSuccess,
  resetScoringConfigFail
} from '../../redux/actions/trm/scoringConfig';
import * as api from '../../services/trm/trmServices';

const networkLayerObject = new api.NetworkLayer();

function* fetchScoringConfigWorker({ payload }) {
  try {
    const data = yield call(networkLayerObject.getScoringConfigAPI, payload);
    yield put(fetchScoringConfigSuccess(data));
  } catch (error) {
    yield put(fetchScoringConfigFail(error?.message || String(error)));
  }
}

function* saveScoringConfigWorker({ payload }) {
  try {
    yield call(networkLayerObject.putScoringConfigAPI, payload);
    yield put(saveScoringConfigSuccess(payload.config));
    message.success('Saved. Takes effect at next champion promotion.');
  } catch (error) {
    const msg = error?.message || 'Failed to save scoring config';
    yield put(saveScoringConfigFail(msg));
    message.error(msg);
  }
}

function* resetScoringConfigWorker({ payload }) {
  try {
    yield call(networkLayerObject.deleteScoringConfigAPI, payload);
    yield put(resetScoringConfigSuccess());
    message.success('Reset to defaults. Takes effect at next champion promotion.');
  } catch (error) {
    const msg = error?.message || 'Failed to reset scoring config';
    yield put(resetScoringConfigFail(msg));
    message.error(msg);
  }
}

export function* watchFetchScoringConfig() {
  yield takeLatest(FETCH_SCORING_CONFIG, fetchScoringConfigWorker);
}
export function* watchSaveScoringConfig() {
  yield takeLatest(SAVE_SCORING_CONFIG, saveScoringConfigWorker);
}
export function* watchResetScoringConfig() {
  yield takeLatest(RESET_SCORING_CONFIG, resetScoringConfigWorker);
}
